<template>
  <Row>
    <Col span="12" class="c-col" v-for="slide in data" :key="slide.id">
      <div class="c-item" :class="{ 'c-checked': activeName(slide.id), 'c-disabled': slide.disabled }" @click="parentAdd(slide)">
        <div class="c-item-box">
          <Icon :type="slide.icon" size="20" />
          <span>{{ slide.name }}</span>
        </div>
      </div>
    </Col>
  </Row>
</template>
<script>
export default {
  name: 'clock',
  props: {
    data: {
      type: Array
    },
    value: {
      type: Number
    }
  },
  computed: {
    activeName(id) {
      return (id) => {
        return id === this.value
      }
    }
  },
  methods: {
    parentAdd(slide) {
      const { id, disabled } = slide
      if (disabled || !id) return
      this.$emit('on-add', id)
    }
  }
}
</script>
<style lang="scss" scoped>
.c-col {
  &:nth-child(4n + 1) {
    box-shadow: 1px 0 0 0 #eee;
  }

  &:nth-child(4n + 2) {
    box-shadow: 0 -1px 0 0 #eee inset;
  }

  &:nth-child(4n + 3) {
    box-shadow: 0 -1px 0 0 #eee;
    border-bottom: 1px solid #eee;
  }

  &:nth-child(4n) {
    box-shadow: 1px 0 0 0 #eee inset;
    border-bottom: 1px solid #eee;
  }
}

.c-item {
  padding-bottom: 100%;
  position: relative;
  cursor: pointer;
  user-select: none;

  .c-item-box {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 80%;
    height: 80%;
    position: absolute;
    top: 10%;
    left: 10%;
  }

  &.c-checked {
    background-color: #f8f8f8;

    span,
    i {
      color: #4b77ee;
    }
  }

  &.c-disabled:hover {
    color: #cccccc;
    background-color: #f7f7f7;
    border-color: #dcdee2;
    cursor: not-allowed;
  }

  span {
    font-size: 14px;
    line-height: 22px;
    margin-top: 4px;
  }
}
</style>
